import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PmaxPreviewData } from '../../../../../../../models/google-template/preview-interfaces/pmax-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { DesktopFrameComponent } from '../../../preview-common/desktop-frame/desktop-frame.component';

/**
 * Performance Max on the YouTube watch page (desktop): square image ad at the top of the up-next column,
 * with headline, description, Sponsored line and CTA button. The player and the other suggestions are
 * skeleton placeholders.
 */
@Component({
  selector: 'app-pmax-youtube-desktop-03',
  imports: [CommonModule, DesktopFrameComponent],
  templateUrl: './youtube-desktop-03.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './youtube-desktop-03.component.scss'
})
export class PmaxYoutubeDesktop03PreviewComponent {
  @Input() data!: PmaxPreviewData;

  /** Skeleton up-next suggestions below the ad. */
  readonly fillerRows = [0, 1, 2];

  /** Skeleton description lines under the player. */
  readonly descLines = [0, 1, 2, 3];

  readonly creativeFormat: CreativeFormat = 'square';
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  /** The uploaded creative matching {@link creativeFormat}, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }

  get headline(): string {
    return this.data.headlines[0] || 'Your headline appears here';
  }

  get description(): string {
    return this.data.descriptions[0] || 'Your description appears here';
  }

  get ctaText(): string {
    return this.data.ctaText || 'Book now';
  }
}
